import React, { useEffect, useRef, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../api/client";

export function CertificateGenerate() {
  const { slug } = useParams<{ slug: string }>();
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const requestDone = useRef(false);

  useEffect(() => {
    if (!slug || requestDone.current) return;
    requestDone.current = true;
    api
      .post(`/courses/${slug}/certificate`)
      .then((res) => {
        if (res.data.success && res.data.data?.pdfUrl) setPdfUrl(res.data.data.pdfUrl);
        else setError(res.data.message || "Could not generate certificate.");
      })
      .catch((err) => setError(err.response?.data?.message || "Could not generate certificate."))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="max-w-2xl mx-auto px-4 py-16">
        <div className="rounded-2xl border border-gray-200 bg-white p-10 text-center">
          <p className="text-gray-500 font-medium">Generating certificate…</p>
          <div className="mt-4 h-1 w-32 mx-auto bg-gray-100 rounded-full overflow-hidden">
            <div className="h-full w-1/2 bg-gold-400 rounded-full animate-pulse" />
          </div>
        </div>
      </div>
    );
  }
  if (error) {
    return (
      <div className="max-w-2xl mx-auto px-4 py-16">
        <div className="rounded-2xl border border-red-200 bg-red-50 p-8 text-center">
          <p className="text-red-600 font-medium">{error}</p>
          <Link
            to="/dashboard/certificates"
            className="mt-4 inline-block font-semibold text-gold-500 hover:text-gold-400 transition-colors"
          >
            Back to certificates
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="rounded-2xl border border-gray-200 bg-white p-8 md:p-10 shadow-soft-lg text-center">
        <p className="text-gold-500 font-semibold text-xs tracking-[0.2em] uppercase">
          Success
        </p>
        <h1 className="font-serif text-3xl font-semibold text-ink-950 tracking-tight mt-2">
          Certificate ready
        </h1>
        <p className="mt-2 text-gray-600">
          Your certificate has been generated. Download it below.
        </p>
        {pdfUrl && (
          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-8 inline-block rounded-lg bg-gold-400 px-6 py-3.5 text-ink-950 font-semibold hover:bg-gold-300 transition-colors shadow-md"
          >
            Download PDF
          </a>
        )}
        <Link
          to="/dashboard/certificates"
          className="block mt-6 font-semibold text-gold-500 hover:text-gold-400 transition-colors"
        >
          View all certificates
        </Link>
      </div>
    </div>
  );
}
